class ProductDescriptionTruncate extends HTMLElement {
  constructor() {
    super();
    this.description = this.querySelector('.product__description--truncated');
    this.toggleButton = this.querySelector('.product__description-toggle');
    
    if (!this.description || !this.toggleButton) return;
    
    this.init();
  }

  init() {
    // Apply line clamp based on screen size
    this.applyLineClamp();
    
    // Check if content is actually truncated
    this.checkTruncation();
    
    // Add event listener
    this.toggleButton.addEventListener('click', this.toggle.bind(this));
    
    // Re-check on resize
    window.addEventListener('resize', this.debounce(() => {
      if (!this.description.classList.contains('expanded')) {
        this.applyLineClamp();
        this.checkTruncation();
      }
    }, 250));
  }

  applyLineClamp() {
    const isMobile = window.innerWidth < 750;
    const lines = isMobile 
      ? this.description.dataset.mobileLines 
      : this.description.dataset.desktopLines;
    
    // Remove inline styles first
    this.description.style.webkitLineClamp = '';
    
    // Apply line clamp via style attribute for dynamic values
    if (!this.description.classList.contains('expanded')) {
      this.description.style.webkitLineClamp = lines;
    }
  }

  checkTruncation() {
    // Temporarily remove line clamp to check full height
    const currentLineClamp = this.description.style.webkitLineClamp;
    this.description.style.webkitLineClamp = 'unset';
    
    const fullHeight = this.description.scrollHeight;
    
    // Restore line clamp
    this.description.style.webkitLineClamp = currentLineClamp;
    
    const truncatedHeight = this.description.clientHeight;
    const isTruncated = fullHeight > truncatedHeight;
    
    this.toggleButton.style.display = isTruncated ? 'inline-flex' : 'none';
  }

  toggle() {
    const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.description.classList.add('expanded');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    
    // Remove line clamp styles
    this.description.style.webkitLineClamp = 'unset';
  }

  collapse() {
    this.description.classList.remove('expanded');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    
    // Reapply line clamp
    this.applyLineClamp();
    
    // Scroll back to description top
    this.description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('product-description-truncate', ProductDescriptionTruncate);